export const accountTypeConstants = {
  RETRIEVE_ACCOUNT_TYPES: 'RETRIEVE_ACCOUNT_TYPES',
}
